/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    active: {
      description: 'Used to mark currently active Item or and ItemGroup containing the currently active Item',
      type: 'state',
      values: [ true, false ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    type: {
      description: '`parent` being the toggle button for an ItemsGroup, and `child` an element of the ItemGroup',
      type: 'state',
      values: [ 'child', 'parent' ]
    }
  },
  rules: [
    {
      if: { type: 'child' },
      tokens: {
        backgroundColor: '#f5eded',
        fontName: 'SofiaPro',
        fontWeight: '400'
      }
    },
    { if: { hover: true }, tokens: { backgroundColor: '#fce6df' } },
    { if: { focus: true }, tokens: { backgroundColor: '#fce6df' } },
    {
      if: { active: true, type: 'child' },
      tokens: {
        accentBackgroundColor: '#f39d80',
        backgroundColor: '#f5f5f7',
        fontName: 'SofiaPro',
        fontSize: 16,
        fontWeight: '700'
      }
    },
    {
      if: { active: true },
      tokens: { accentBackgroundColor: '#f39d80', backgroundColor: '#f5f5f7' }
    },
    {
      if: { active: true, type: 'parent' },
      tokens: {
        accentBackgroundColor: 'rgba(0, 0, 0, 0)',
        backgroundColor: '#f9cebf'
      }
    }
  ],
  tokens: {
    accentBackgroundColor: 'rgba(0, 0, 0, 0)',
    accentOffset: 0,
    accentPadding: 0,
    accentWidth: 4,
    backgroundColor: '#f9cebf',
    borderColor: '#f39d80',
    borderStyle: 'solid',
    borderWidth: 1,
    color: '#394056',
    fontName: 'SofiaPro',
    fontSize: 18,
    fontWeight: '700',
    justifyContent: 'flex-start',
    lineHeight: 1.56,
    paddingBottom: 10,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 10
  }
}
export default theme
